import { render, staticRenderFns } from "./AppNavigationMemberItem.vue?vue&type=template&id=1cc87b2a&scoped=true&"
import script from "./AppNavigationMemberItem.vue?vue&type=script&lang=js&"
export * from "./AppNavigationMemberItem.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationMemberItem.vue?vue&type=style&index=0&id=1cc87b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc87b2a",
  null
  
)

export default component.exports